// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7916":"css/app.7040","8081":"css/admin-app.7040"}[chunkId] + ".css";
};